invalidWorkerResultType